const swiftRegEx = /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
const ibanRegEx = /^([A-Z]{2})(\d{2})([A-Z\d]+)$/;

const IBANCodeLengths = {
  AD: 24,
  ES: 24,
  FR: 27,
};

const test = (regEx, value) => regEx.test(value.toUpperCase());
const isValidSwift = (swift) => test(swiftRegEx, swift);

const isValidIBANNumber = (input) => {
  const iban = String(input)
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

  const code = iban.match(ibanRegEx);
  if (!code || iban.length !== IBANCodeLengths[code[1]]) {
    return false;
  }

  const digits = (code[3] + code[1] + code[2]).replace(
    /[A-Z]/g,
    (letter) => letter.charCodeAt(0) - 55
  );

  return mod97(digits);
};

const mod97 = (string) => {
  let checksum = string.slice(0, 2);

  for (let offset = 2; offset < string.length; offset += 7) {
    const fragment = String(checksum) + string.substring(offset, offset + 7);
    checksum = parseInt(fragment, 10) % 97;
  }

  return checksum;
};

export default {
  isValidSwift,
  isValidIBANNumber,
};
